import { isEqual } from 'lodash';
import { getGroupAppointmentsIds } from 'modules/queues/common/selectors/groupAppointmentsIds';
import { startObserveGroupAppointmentsUpdate } from 'modules/websocket/actions/appointmentGroupUpdate';

import createAction from '.';

export const SET_GROUP_APPOINTMENTS_IDS = createAction('SET_GROUP_APPOINTMENTS_IDS');

export const resubscribeGroupAppointmentsUpdates = (dispatch, getState) => {
  const state = getState();
  const { groupAppointmentsIds } = state.queues.common.appointmentInfo;
  const newGroupAppointmentIds = getGroupAppointmentsIds(state);

  if (!isEqual(groupAppointmentsIds.sort(), newGroupAppointmentIds.sort()) && newGroupAppointmentIds.length) {
    dispatch({
      type: SET_GROUP_APPOINTMENTS_IDS,
      payload: { groupAppointmentsIds: newGroupAppointmentIds },
    });

    dispatch(startObserveGroupAppointmentsUpdate(newGroupAppointmentIds));
  }
};
